import { Form, message, Spin } from 'antd';
import { useMutation } from 'react-query';
import { useLocation, useHistory } from 'react-router-dom';
import useHttpClient from '../../../shared/sendRequest/useHttpClient';
import EndPoints from '../../../shared/endPoints/EndPoints.json';
import AuthLayout from '../../../components/AuthLayout/AuthLayout';
import AuthCard from '../../../components/AuthCard/AuthCard';
import useAuthFlowRouteGuard from '../../../shared/hooks/useAuthFlowRouteGuard';
import NewPasswordFields from './NewPasswordFields';
import PasswordSubmitButton from './PasswordSubmitButton';

export default function ResetPassword() {
  const { search } = useLocation();
  const history = useHistory();
  const [form] = Form.useForm();
  const { sendRequest } = useHttpClient();

  const searchParams = new URLSearchParams(search);
  const username = searchParams.get('username');
  const token = searchParams.get('token');

  const shouldRender = useAuthFlowRouteGuard(!!username && !!token);

  const { mutate, isLoading } = useMutation(sendRequest, {
    onSuccess: () => {
      message.success('Η δημιουργία νέου κωδικού πραγματοποιήθηκε με επιτυχία');
      history.replace('/');
    }
  });

  if (!shouldRender) return null;

  const onFinish = values => {
    mutate({
      endpoint: EndPoints.USERACCOUNT.RESETPASSWORD,
      method: 'POST',
      bodyData: {
        username,
        token,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword
      }
    });
  };

  return (
    <AuthLayout>
      <Spin spinning={isLoading} size="large">
        <AuthCard
          title="Επαναφορά Κωδικού"
          subtitle="Δημιούργησε ένα νέο ισχυρό κωδικό πρόσβασης"
        >
          <Form form={form} onFinish={onFinish} layout="vertical">
            <NewPasswordFields
              name="newPassword"
              label="Νέος κωδικός πρόσβασης"
              confirmLabel="Επιβεβαίωση νέου κωδικού πρόσβασης"
              requiredMessage="Παρακαλώ εισάγετε νέο κωδικό πρόσβασης"
              confirmRequiredMessage="Παρακαλώ επιβεβαιώστε τον νέο κωδικό πρόσβασης"
            />
            <PasswordSubmitButton form={form} passwordName="newPassword">
              Επόμενο
            </PasswordSubmitButton>
          </Form>
        </AuthCard>
      </Spin>
    </AuthLayout>
  );
}
